import { By, ObjectId, Timestamp } from "../../../types";

export type Access =
  | "ReceiveCheque"
  | "ConfirmCheque"
  | "DeliverCheque"
  | "SpendCheque"
  | "ReceiveCash"
  | "SpendCash"
  | "EditCash"
  | "AddEditCustomer"
  | "EditFactorCheque"
  | "Admin";

export type AccessList = Array<Access>;

export enum UserStatus {
  None = 0,
  Offline,
  Online,
}

export interface AccessListDiff {
  new: AccessList;
  del: AccessList;
}

export interface UserUpdateInfo {
  date: Timestamp;
  by: By;
  access_diff: AccessListDiff;
}

export type UserUpdates = Array<UserUpdateInfo>;

export interface UserProps {
  fullname: string;
  role: string;
  pic: string;
  username: string;
  access_list: AccessList;
  updates: UserUpdates;
  status: UserStatus;
  _id: ObjectId;
}
